/**
 * Format a date string with time (e.g., "8:30AM Tue Dec 29 2026")
 * @param {string} dateStr - ISO date string (e.g., "2026-12-29T08:30:00.000Z")
 * @returns {string} - Formatted date string
 */
export function formatDateTime(dateStr) {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  
  // Format time (e.g., "8:30AM" or "12:05PM")
  const time = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).replace(/\s/g, ''); // Remove space between time and AM/PM
  
  // Format date (e.g., "Tue Dec 29 2026")
  const datePart = date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  
  return `${time} ${datePart}`;
}

/**
 * Get today's date in local timezone as YYYY-MM-DD format
 * @returns {string} - Today's date in YYYY-MM-DD format (local timezone)
 */
export function getLocalTodayString() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Format a date string without time (e.g., "Tue Dec 29 2026")
 * @param {string} dateStr - ISO date string
 * @returns {string} - Formatted date string
 */
export function formatDate(dateStr) {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Format a date string as "Month Day, Year" (e.g., "June 4, 2026")
 * @param {string} dateStr - ISO date string (UTC)
 * @returns {string} - Formatted date string in local timezone
 */
export function formatDateLong(dateStr) {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Format a date string as "Month Day Year" without comma (e.g., "June 4 2026")
 * @param {string} dateStr - ISO date string (UTC)
 * @returns {string} - Formatted date string in local timezone
 */
export function formatDateLongNoComma(dateStr) {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).replace(',', '');
}
